@for (item of renderedMessages(); track $index) {
  @if (item.message.role === "user") {
    <div class="agent-message agent-message--user">
      <div class="agent-message__bubble">
        @for (segment of item.segments; track $index) {
          @if (segment.campaignId !== null) {
            <button type="button" class="agent-chip" data-kind="campaign" (click)="onMentionClick(segment.mention)">{{ segment.text }}</button>
          } @else if (segment.mention) {
            <span class="agent-chip" [attr.data-kind]="segment.mention.kind">{{ segment.text }}</span>
          } @else {
            <ng-container>{{ segment.text }}</ng-container>
          }
        }
      </div>
    </div>
  } @else {
    <div class="agent-message agent-message--assistant" [class.agent-message--errored]="item.message.status === 'error'">
      @for (block of item.message.blocks; track block.index) {
        @switch (block.kind) {
          @case ("text") {
            <div class="agent-message__text agent-md" [innerHTML]="block.text | markdown: 'link'" (click)="onContentClick($event)"></div>
          }
          @case ("tool_use") {
            <app-agent-tool-call [block]="block"></app-agent-tool-call>
          }
        }
      }

      @if (item.templateCards.length > 0) {
        <app-agent-template-picker
          [cards]="item.templateCards"
          [active]="item.templatePickerActive"
          (pick)="pickTemplate.emit($event)"></app-agent-template-picker>
      }

      @if (item.audiences.length > 0) {
        <app-agent-audience-list [audiences]="item.audiences" (openAudience)="openAudience.emit($event)"></app-agent-audience-list>
      }

      @if (item.message.confirmation; as confirmation) {
        <app-agent-confirmation [confirmation]="confirmation" (approve)="approve.emit(confirmation)" (deny)="deny.emit(confirmation)"></app-agent-confirmation>
      }

      @if (item.waiting) {
        <app-agent-thinking></app-agent-thinking>
      }

      @if (item.hadFailedTool) {
        <div class="agent-message__tool-error">{{ "agent.tool-failed" | translate }}</div>
      }

      @if (item.message.status === "stopped") {
        <div class="agent-message__stopped">{{ "agent.stopped" | translate }}</div>
      }

      @if (item.message.status === "error") {
        <div class="agent-message__error">
          <span [attr.title]="item.message.error">{{ item.errorTextKey | translate }}</span>
          @if (item.retryable) {
            <button type="button" class="agent-message__retry" (click)="retry.emit()">
              {{ "agent.retry" | translate }}
            </button>
          }
        </div>
      }

      @if (item.copyText || item.ratable) {
        <div class="agent-message__actions">
          @if (item.copyText) {
            <button
              type="button"
              class="agent-message__action"
              [attr.aria-label]="'agent.copy' | translate"
              [matTooltip]="(copiedIndex() === $index ? 'agent.copied' : 'agent.copy') | translate"
              (click)="copy($index, item.copyText)">
              <mat-icon>{{ copiedIndex() === $index ? "check" : "content_copy" }}</mat-icon>
            </button>
          }
          @if (item.ratable) {
            <button
              type="button"
              class="agent-message__action"
              [class.agent-message__action--active]="item.rating === 'up'"
              [attr.aria-pressed]="item.rating === 'up'"
              [attr.aria-label]="'agent.rate.up' | translate"
              [matTooltip]="'agent.rate.up' | translate"
              (click)="onRate(item, 'up')">
              <mat-icon>{{ item.rating === "up" ? "thumb_up" : "thumb_up_off_alt" }}</mat-icon>
            </button>
            <button
              type="button"
              class="agent-message__action"
              [class.agent-message__action--active]="item.rating === 'down'"
              [attr.aria-pressed]="item.rating === 'down'"
              [attr.aria-label]="'agent.rate.down' | translate"
              [matTooltip]="'agent.rate.down' | translate"
              (click)="onRate(item, 'down')">
              <mat-icon>{{ item.rating === "down" ? "thumb_down" : "thumb_down_off_alt" }}</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  }
}
